var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUscCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 180 180",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#0A0D0F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 105.95V69.9007H115.713V105.954C115.713 120.176 104.2 131.702 89.9982 131.702C75.7963 131.702 64.2831 120.173 64.2831 105.954V49.3015H95.1398V39H54V105.95C54 125.859 70.1177 142 89.9982 142C109.882 142 126 125.863 126 105.95Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.425 39V49.315H115.712V59.6264H125.998V39H105.425Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUscCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/USCCircle.46ea0ac8.svg";
export { ForwardRef as ReactComponent };